module.exports = __webpack_public_path__ + "static/img/bg-pt.32e029d6.png";